import reducer from 'src/utils/redux/reducer';
import {
  SET_FILTER, SET_BUILDER, SET_PIPELINE,
  CONTENT_DID_MOUNT,
  FILTER_OPEN, FILTER_CLOSE,
  MENU_OPEN, MENU_CLOSE,
  PIPELINE_OPEN, PIPELINE_CLOSE, PIPELINE_SIDE,
  PIPELINE_SAVED_SHOW_OWN, PIPELINE_SAVED_SHOW_COMMON,
} from './types';
import { TYPE_PIPELINE_SIDE } from 'src/types/ui';

// --- initialState ---

export const initialState = {
  withFilter: false,
  withBuilder: false,
  withPipeline: false,

  content: {
    didMount: false,
  },
  filter: {
    isOpened: false,
  },
  menu: {
    isOpened: false,
  },
  pipeline: {
    isOpened: false,
    side: TYPE_PIPELINE_SIDE.BOTTOM,
    savedList: {
      showOwn: true,
      showCommon: true,
    },
  },
};


// --- handlers ---

const handleSetInitial = () => initialState;

const handleSetFilter = (state, action) => ({
  ...state,
  withFilter: action.payload,
});

const handleSetBuilder = (state, action) => ({
  ...state,
  withBuilder: action.payload,
});

const handleSetPipeline = (state, action) => ({
  ...state,
  withPipeline: action.payload,
});

const handleContentDidMount = state => ({
  ...state,
  content: {
    ...state.pipeline,
    didMount: true,
  },
});

const handleFilterOpen = state => ({
  ...state,
  filter: {
    ...state.filter,
    isOpened: false,
  },
});

const handleFilterClose = state => ({
  ...state,
  filter: {
    ...state.filter,
    isOpened: false,
  },
});

const handleMenuOpen = state => ({
  ...state,
  menu: {
    ...state.menu,
    isOpened: true,
  },
});

const handleMenuClose = state => ({
  ...state,
  menu: {
    ...state.menu,
    isOpened: false,
  },
});

const handlePipelineOpen = state => ({
  ...state,
  pipeline: {
    ...state.pipeline,
    isOpened: true,
  },
});

const handlePipelineClose = state => ({
  ...state,
  pipeline: {
    ...state.pipeline,
    isOpened: false,
  },
});

const handlePipelineSide = (state, action) => ({
  ...state,
  pipeline: {
    ...state.pipeline,
    side: action.side,
  },
});

const handlePipelineSavedShowOwn = (state, actions) => ({
  ...state,
  pipeline: {
    ...state.pipeline,
    savedList: {
      ...state.pipeline.savedList,
      showOwn: !!actions.show,
    },
  },
});

const handlePipelineSavedShowCommon = (state, actions) => ({
  ...state,
  pipeline: {
    ...state.pipeline,
    savedList: {
      ...state.pipeline.savedList,
      showCommon: !!actions.show,
    },
  },
});

const handlers = {
  'SET_INITIAL': handleSetInitial,
  [SET_FILTER]: handleSetFilter,
  [SET_BUILDER]: handleSetBuilder,
  [SET_PIPELINE]: handleSetPipeline,
  [CONTENT_DID_MOUNT]: handleContentDidMount,
  [FILTER_OPEN]: handleFilterOpen,
  [FILTER_CLOSE]: handleFilterClose,
  [MENU_OPEN]: handleMenuOpen,
  [MENU_CLOSE]: handleMenuClose,
  [PIPELINE_OPEN]: handlePipelineOpen,
  [PIPELINE_CLOSE]: handlePipelineClose,
  [PIPELINE_SIDE]: handlePipelineSide,
  [PIPELINE_SAVED_SHOW_OWN]: handlePipelineSavedShowOwn,
  [PIPELINE_SAVED_SHOW_COMMON]: handlePipelineSavedShowCommon,
};

// --- reducerFactory ---

export default flows => reducer({ initialState, handlers, flows });